import React, {PureComponent, Fragment} from 'react';
import injectSheet, {withTheme} from 'react-jss'
import {connect} from "react-redux"
import {getTrending, getLoadingTrending} from "../selectors"
import Spinner from "./Widgets/Spinner"
import Section from './Widgets/Section'
import SectionTitle from './Widgets/SectionTitle'
import flow from 'lodash/flow'
import CardGrid from './Card/CardGrid'

class Trending extends PureComponent {

    render() {
        const {classes, theme, trending, loadingTrending} = this.props;
        const trendingCount = !trending || !trending.length? 0 : trending.length

        if( !loadingTrending && (!trending || trendingCount === 0)) return null;

        return (
          <React.Fragment>
            <SectionTitle text='Trending' color={theme.colors.trending} dataCy='trendingTitle' />
            <Section key='content' className={classes.root} dataCy='trendingContent'>
                <Spinner show={loadingTrending} className={classes.spinnerContainer} />
                {!loadingTrending &&
                    <Fragment>
                        <CardGrid items={trending} columns={3} variation='trending' showSummary={false}/>
                    </Fragment>
                }
            </Section>
          </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {
        trending: getTrending(state),
        loadingTrending: getLoadingTrending(state)
    }
}

export default flow([
    injectSheet((theme) => (
    {
        root: {
            minHeight: 200,
            position: "relative",
        },
        spinnerContainer: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
    })),
    connect(mapStateToProps),
    withTheme
])(Trending);



// WEBPACK FOOTER //
// ./src/components/Trending.js